window.adev = window.adev || {};

window.adev.deliveryTimerV2 = {
    init(){
        document.querySelectorAll('[data-adev-delivery-timer-v2]:not(.adev-init)').forEach((el, index) => {

            const months = JSON.parse(el.dataset.settings);
            const text = el.dataset.text;

            const timer = function () {
                var currentDate = new Date(),
                    formattedDate = new Intl.DateTimeFormat("en-GB", {
                        dateStyle: "medium",
                        timeStyle: "medium",
                        timeZone: "Europe/Amsterdam"
                    }).format(currentDate),
                    dayOfWeek = (currentDate = new Date(formattedDate)).getDay(),
                    currentHour = currentDate.getHours();
            
                let deliveryDate = new Date(currentDate);
            
                if (currentHour < 22) {
                    // Before 22:00
                    if (dayOfWeek === 6) {
                        // Saturday: always Monday
                        deliveryDate.setDate(deliveryDate.getDate() + 2);
                    } else {
                        // Other days: next day
                        deliveryDate.setDate(deliveryDate.getDate() + 1);
                        // If next day is Sunday (0), set to Monday
                        if (deliveryDate.getDay() === 0) {
                            deliveryDate.setDate(deliveryDate.getDate() + 1);
                        }
                    }
                } else {
                    // After 22:00
                    switch (dayOfWeek) {
                        case 1: // Monday → Wednesday
                            deliveryDate.setDate(deliveryDate.getDate() + 2);
                            break;
                        case 2: // Tuesday → Thursday
                            deliveryDate.setDate(deliveryDate.getDate() + 2);
                            break;
                        case 3: // Wednesday → Friday
                            deliveryDate.setDate(deliveryDate.getDate() + 2);
                            break;
                        case 4: // Thursday → Friday
                            deliveryDate.setDate(deliveryDate.getDate() + 1);
                            break;
                        case 5: // Friday → Monday
                        case 6: // Saturday → Monday
                        case 0: // Sunday → Monday
                            // Calculate days to next Monday
                            deliveryDate.setDate(deliveryDate.getDate() + ((8 - dayOfWeek) % 7));
                            break;
                    }
                }
            
                let cutoffTime = new Date(currentDate);
                cutoffTime.setHours(22, 0, 0, 0);
            
                if (currentHour >= 22) {
                    cutoffTime.setDate(cutoffTime.getDate() + 1);
                }
            
                let timeDifference = cutoffTime - currentDate,
                    hours = Math.floor((timeDifference % 86400000) / 3600000).toString().padStart(2, "0"),
                    minutes = Math.floor((timeDifference % 3600000) / 60000).toString().padStart(2, "0"),
                    seconds = Math.floor((timeDifference % 60000) / 1000).toString().padStart(2, "0");
            
                let dateRangeString = '';
            
                dateRangeString += '<strong class="adev-dt__date">';
                dateRangeString += deliveryDate.getDate();
            
                const index = ["january","february","march","april","may","june","july","august","september","october","november","december"][deliveryDate.getMonth()];
            
                let dateString = '<strong class="adev-dt__date">' + deliveryDate.getDate() + ' ' + months[index] + '</strong>';
                dateRangeString += ' ' + months[index];
            
                const nextDay = new Date(deliveryDate);
                nextDay.setDate(deliveryDate.getDate() + 1);
                dateRangeString += ' - ' + nextDay.getDate();
            
                const nextIndex = ["january","february","march","april","may","june","july","august","september","october","november","december"][nextDay.getMonth()];
                dateRangeString += ' ' + months[nextIndex];
            
                dateRangeString += '</strong>';
            
                el.innerHTML = text.replace('[timer]', `<strong class="adev-dt__time">${hours}:${minutes}:${seconds}</strong>`).replace('[date]', dateString).replace('[date_range]', dateRangeString);
            
                el.classList.add('adev-init');
            
                setTimeout(timer, 1000);
            };

            timer();
            
        });
    },
};

window.adev.deliveryTimerV2.init();

document.addEventListener("adev:cart:refreshed", function (event) {
    window.adev.deliveryTimerV2.init();
});

if (Shopify.designMode) {
    window.adev_theme_editor.registerSection(["main-product", "cart-drawer"], {
        load() {
            window.adev.deliveryTimerV2.init();
        }
    });
}